



































































































































import { Component, Vue } from 'vue-property-decorator';
import { Performer } from '@/types/performer';
import { Part, Performance } from '@/types/part';


  @Component({
    components: {
      PerformanceArea: () => import('@/components/PerformanceArea.vue'),
      Part: () => import('@/components/Part.vue'),
      PerformerList: () => import('@/components/PerformerList.vue'),
    },
  })
export default class HelloWorld extends Vue {
    private dialog = false;

    private selected = false;

    private tmpPerformer: Performer = {
      id: 0,
      position: {
        x: 0,
        y: 0,
      },
      shortName: '',
      longName: '',
    };

    private selectedPart = 0;

    private performance: Performance = new Performance([]);

    private parts: any = [
      {
        order: 0,
        name: '黎明',
      },
      {
        order: 1,
        name: '日中',
      },
      {
        order: 2,
        name: '逢魔が時',
      },
      {
        order: 3,
        name: '彼は誰時',
      },
    ];

    mounted() {
      const item: string | null = localStorage.getItem('performerList');
      if (item != null) {
        const performance: Performance = JSON.parse(item);
        this.performance = new Performance(performance.parts);
      }

      const partItem: string | null = localStorage.getItem('parts');
      if (partItem != null) {
        this.parts = JSON.parse(partItem);
      }
    }

    addModalPerformer() {
      this.dialog = true;
      if (this.performance.parts.length === 0) {
        this.tmpPerformer.id = 0;
        return;
      }

      const num = this.performance.parts.reduce((a, b) => (a.id > b.id ? a : b));
      this.tmpPerformer.id = num.id + 1;
    }

    addPerformer() {
      this.dialog = false;

      const tmp = { ...this.tmpPerformer };
      // console.debug(tmp);

      // const findPerformer: Performer[] | undefined =
      if (this.performance.parts.length > 0) {
        console.log('データあり');
        const parts: Part[] = this.performance.parts
          .filter((index) => index.id === this.selectedPart);

        parts[0].performer.push(tmp);
      } else {
        console.log('データなし');
        this.performance.parts = [{
          id: 0,
          name: '',
          performer: [tmp],
        }];
      }
      localStorage.setItem('performerList', JSON.stringify(this.performance));
    }

    editPerformer(editPerformer: Performer) {
      this.selected = true;
      const findPerformer: Performer | undefined = this.performance.parts
        .flatMap((part) => part.performer)
        .find((performer) => performer.id === editPerformer.id, 0);

      if (findPerformer === undefined) {
        console.debug('見つかりませんでした。');
        return;
      }

      this.tmpPerformer = findPerformer;
    }

    editCommitPerformer() {
      this.selected = false;
      localStorage.setItem('performerList', JSON.stringify(this.performance));
    }

    deletePerformer(deletePerformer: Performer) {
      const deleteIndex = this.performance.parts
        .findIndex((performer) => performer.id === deletePerformer.id, 0);

      this.performance.parts.splice(deleteIndex, 1);
      localStorage.setItem('performerList', JSON.stringify(this.performance));
    }

    partPerformer() {
      return this.performance.partPosition(this.selectedPart);
    }

    selectPart(selected: number) {
      this.selectedPart = selected;
    }

    /**
     * 隊列を追加した時のメソッド。
     * 二つの挙動を行うことを目的とする。
     * 1. 隊列を削除した時、対応する隊列を削除する。
     * 2. 隊列を追加した時、一つ前の隊列をコピーする。
     */
    updatePart() {
      const delta = this.performance.parts
        .filter((part) => this.parts
          .map((order: any) => order.order)
          .indexOf(part.id) === -1);

      console.log(delta);

      // 動作未確認
      delta.forEach(
        (deleteOrder: any) => {
          const deleteIndex = this.performance.parts
            .findIndex((performer) => performer.id === deleteOrder, 0);
          this.performance.parts.splice(deleteIndex, 1);
        },
      );

      const delta2 = this.parts
        .filter((part: any) => this.performance.parts
          .map((order: any) => order.id)
          .indexOf(part.order) === -1);

      console.log(delta2);

      delta2.forEach(
        (addOrder: any) => {
          const addIndex = this.performance.parts
            .findIndex((performer) => performer.id === (addOrder.order - 1), 0);

          const add: any = [];
          const copyTarget: Performer[] = this.performance.parts.filter((p) => p.id === addIndex)
            .flatMap((part) => part.performer);

          Object.assign(add, copyTarget);

          const tmpAdd = {
            id: addOrder.order,
            name: addOrder.name,
            performer: add,
          };

          this.performance.parts.push(tmpAdd);
        },
      );

      localStorage.setItem('performerList', JSON.stringify(this.performance));
    }
}
